import { useAppSelector } from '../../../../app/hooks';
import { useUnlockRefreshOpener } from '../../../../common/UnlockRefresh/useUnlockRefreshOpener';
import { REFRESH_UNLOCK_POS } from '../../../../store/investor/constants';
import type { UnlockRefreshOpener } from '../../../../common/UnlockRefresh/types';

export function useMobileRefreshButtonLogic(): UnlockRefreshOpener & { isFetching: boolean; iconColour: string; onClick: () => void } {
    const opener = useUnlockRefreshOpener();
    const modulePollingList = useAppSelector((state) => state.investor.modulePollingList);
    const isFetching = modulePollingList.length > 0;

    return {
        ...opener,
        isFetching,
        iconColour: opener.shouldDisableUnlock ? 'var(--secondary-button-disbaled)' : 'var(--icon-color)',
        onClick: () => opener.openUnlockRefresh(REFRESH_UNLOCK_POS.HEADER_REFRESH_ICON),
    };
}
